"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _portals = require("@mulesoft/exchange-ui-portals-store/lib/domains/portals");
var _DraftHeader = _interopRequireDefault(require("../DraftHeader"));
var _hooks = require("../hooks");
var ViewIcon = function ViewIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.82 8.997C25.297 3.688 20.037 0 13.97 0 7.906 0 2.645 3.688.12 8.997c-.16.335-.16.727 0 1.006C2.645 15.312 7.906 19 13.97 19c6.067 0 11.327-3.688 13.85-8.997.161-.335.161-.67 0-1.006Zm-13.85-7.88c5.581 0 10.421 3.255 12.742 7.94a.941.941 0 0 1 0 .887c-2.32 4.684-7.16 7.938-12.741 7.938-5.581 0-10.421-3.254-12.742-7.938-.148-.247-.148-.592 0-.888C3.55 4.372 8.389 1.118 13.97 1.118Zm0 14.53a6.147 6.147 0 1 0 0-12.294 6.147 6.147 0 0 0 0 12.295Zm0-1.117a5.03 5.03 0 1 0 0-10.059 5.03 5.03 0 0 0 0 10.06Z"
  }));
};
ViewIcon.defaultProps = {
  viewBox: "0 0 28 19",
  xmlns: "http://www.w3.org/2000/svg"
};
var DraftHeaderViewMode = function DraftHeaderViewMode(_ref) {
  var isPageComponent = _ref.isPageComponent,
    _ref$isLoading = _ref.isLoading,
    isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading;
  var _useViewModeActions = (0, _hooks.useViewModeActions)(),
    publishedURL = _useViewModeActions.publishedURL,
    editURL = _useViewModeActions.editURL,
    onDiscard = _useViewModeActions.onDiscard,
    onPublish = _useViewModeActions.onPublish;
  var isPublishing = (0, _reactRedux.useSelector)(_portals.selectors.isPublishing);
  var buttons = _react.default.useMemo(function () {
    if (isLoading) {
      return [];
    }
    if (isPageComponent) {
      return [{
        title: 'Discard',
        description: 'Discard draft',
        onClick: onDiscard,
        noFill: true
      }, {
        title: 'View published',
        description: 'Return to published documentation',
        href: publishedURL,
        noFill: true
      }, {
        title: 'Edit',
        description: 'Edit draft',
        href: editURL,
        noFill: true
      }, {
        title: 'Publish',
        description: 'Publish draft',
        onClick: onPublish,
        isLoading: isPublishing,
        noFill: false
      }];
    }
    return [{
      title: 'View published',
      description: 'Return to published documentation',
      href: publishedURL,
      noFill: true
    }];
  }, [editURL, isPublishing, isPageComponent, isLoading, publishedURL, onDiscard, onPublish]);
  return /*#__PURE__*/_react.default.createElement(_DraftHeader.default, {
    buttons: buttons,
    statusText: "Viewing draft",
    statusIcon: /*#__PURE__*/_react.default.createElement(ViewIcon, null)
  });
};
var _default = exports.default = DraftHeaderViewMode;
//# sourceMappingURL=DraftHeaderViewMode.js.map